// House Heads At Sea 2027: The Europe Experience — content module
// Sails June 17–26, 2027 aboard Celebrity Equinox, round-trip Barcelona.

const EVENT = {
  name: "House Heads At Sea",
  year: "2027",
  tagline: "The Europe Experience",
  edition: "House Heads At Sea Goes International",
  ship: "Celebrity Equinox",
  cruiseLine: "Celebrity Cruises",
  date: "June 17, 2027",
  dateShort: "JUN 17TH, 2027",
  duration: "9-Night Spain, Portugal & Morocco Cruise",
  departurePort: "Barcelona, Spain",
  phone: "470-632-8963",
  phoneHref: "tel:+14706328963",
  bookingUrl: "https://traveljoy.com/bookings/8t1sNbHyGfXLFtqN8SuWhUe7",
  website: "HouseHeadsAtSea.com",
  poweredBy: "Powered by DJ DaVyne & Kompass Events",
  depositFrom: "$300",
  holdFor: "$100",
  finalPayoff: "March 16, 2027",
  badge: "House Heads Goes International",
  portsIntro: "Four unforgettable ports across Spain, Portugal and Morocco — Seville, Lisbon (overnight during SuncéBeat), Porto and Tangier. History, culture and cuisine between the parties.",
  id: "europe-2027",
};

const COLORS = {
  red: "#E50914",
  black: "#0A0A0A",
  charcoal: "#1A1A1A",
  silver: "#B3B3B3",
  white: "#FFFFFF",
  green: "#1B8A5A",
  yellow: "#84FE2A",
};

const HERO_IMAGE = "/assets/europe/hero-equinox.jpg?v=3";
const SHIP_IMAGE = "/assets/europe/hero-equinox.jpg?v=3";

const DJS = [
  { name: "DJ DaVyne", role: "Host DJ", img: "/djs/final_davyne.png?v=4" },
  { name: "DJ T-Wise", role: "Co-Host DJ", img: "/djs/final_twise.png?v=4" },
  { name: "DJ PHD", role: "Co-Host DJ", img: "/djs/final_dj_phd.png?v=1" },
  { name: "DJ QuesTune", role: "Co-Host DJ", img: "/djs/final_questune.png?v=4" },
  { name: "DJ Randall Smooth", role: "Co-Host DJ", img: "/djs/final_randall_smooth.png?v=4" },
  { name: "To Be Announced", role: "Major Headliner", img: "/djs/coming-soon.png?v=3" },
  { name: "To Be Announced", role: "Major Headliner", img: "/djs/coming-soon.png?v=3" },
];

const PORTS = [
  {
    name: "Barcelona",
    country: "Spain",
    note: "Embarkation Port",
    time: "Embark 5:00 PM",
    excursion:
      "Gaudí's masterpieces, Las Ramblas and Mediterranean energy before we set sail.",
    img: "/assets/europe/ports/barcelona.jpg",
  },
  {
    name: "Seville",
    country: "Cádiz, Spain",
    note: "Flamenco & History",
    time: "Docked 7am - 5pm",
    excursion:
      "Dock in Cádiz and discover Seville — flamenco, cathedrals and Andalusian charm.",
    img: "/assets/europe/ports/seville.jpg",
  },
  {
    name: "Lisbon",
    country: "Portugal",
    note: "Overnight • SuncéBeat",
    time: "Overnight in Port",
    excursion:
      "Two days in Lisbon during SuncéBeat New Horizons — house music by the Atlantic at Costa da Caparica.",
    img: "/assets/europe/ports/lisbon.jpg",
  },
  {
    name: "Porto",
    country: "Leixões, Portugal",
    note: "Port Wine Country",
    time: "Docked 8am - 6pm",
    excursion:
      "Explore historic Porto, the Douro riverfront and world-famous port wine cellars.",
    img: "/assets/europe/ports/porto.jpg",
  },
  {
    name: "Tangier",
    country: "Morocco",
    note: "North African Gateway",
    time: "Docked 7am - 6pm",
    excursion:
      "Cross into Morocco — medinas, markets and the meeting of two continents.",
    img: "/assets/europe/ports/tangier.jpg",
  },
];

const ITINERARY = [
  {
    day: "PRE-CRUISE",
    date: "WED, JUN 16",
    port: "Barcelona, Spain",
    time: "7:00 PM - 2:00 AM",
    events: ["Meet & Greet + Swag Distribution (7pm)", "Launch Party (9pm)"],
  },
  {
    day: "DAY 1",
    date: "THU, JUN 17",
    port: "Barcelona, Spain",
    time: "Embark 5:00 PM",
    events: ["Meet & Greet + Swag", "Group Pictures (7pm)", "Bienvenidos: Red, Black & White Sail-Away Party (9pm)"],
  },
  {
    day: "DAY 2",
    date: "FRI, JUN 18",
    port: "At Sea",
    time: "Full Day at Sea",
    events: ["Group Breakfast", "Unity Games (Spades, Dominoes, Bid Whist)", "Group Dinner", "The Mediterranean Blue & White Party"],
  },
  {
    day: "DAY 3",
    date: "SAT, JUN 19",
    port: "Seville (Cádiz), Spain",
    time: "Docked 7am - 5pm",
    events: ["Group Breakfast", "House Heads Gone Wild — Discover Seville", "Swimsuit Splash Pool Party", "The Flamenco Party (Red, White, Orange & Yellow)"],
  },
  {
    day: "DAY 4",
    date: "SUN, JUN 20",
    port: "Lisbon, Portugal",
    time: "9:00am - Overnight",
    events: ["Group Breakfast", "House Heads at SuncéBeat", "House Heads at the Beach", "Lisbon After Dark — Costa da Caparica"],
  },
  {
    day: "DAY 5",
    date: "MON, JUN 21",
    port: "Lisbon, Portugal",
    time: "All Day - 6:00pm",
    events: ["Group Breakfast", "House Heads at SuncéBeat", "Movie Night"],
  },
  {
    day: "DAY 6",
    date: "TUE, JUN 22",
    port: "Porto (Leixões), Portugal",
    time: "Docked 8am - 6pm",
    events: ["Group Breakfast", "Group Excursion — House Heads International", "Group Dinner", "The Masquerade Flamenco Party"],
  },
  {
    day: "DAY 7",
    date: "WED, JUN 23",
    port: "At Sea",
    time: "Full Day at Sea",
    events: ["Group Breakfast", "Sol y Sangria — Sunset Party", "Unity Games", "Rep Your City Party"],
  },
  {
    day: "DAY 8",
    date: "THU, JUN 24",
    port: "Tangier, Morocco",
    time: "Docked 7am - 6pm",
    events: ["Group Breakfast", "House Heads Gone Wild — Discover Morocco", "Noche Roja — The Red Night"],
  },
  {
    day: "DAY 9",
    date: "FRI, JUN 25",
    port: "At Sea",
    time: "Full Day at Sea",
    events: ["Negligée & Pajamas Birthday Breakfast", "Day Party — Sun Dress & Shorts", "Final Group Pictures", "La Noche Blanca — Spanish White Party"],
  },
  {
    day: "DAY 10",
    date: "SAT, JUN 26",
    port: "Barcelona, Spain",
    time: "Disembark 5:00 AM",
    events: ["Thank You & Shout-Outs", "Disembark Celebrity Equinox", "Safe Travels Home"],
  },
];

const BOOKING_BASE =
  "https://traveljoy.com/bookings/8t1sNbHyGfXLFtqN8SuWhUe7/client/edit?package_token=";

const CABINS = [
  {
    name: "Inside Stateroom",
    price: "$2,746.00",
    featured: false,
    drinks: false,
    size: "183–200 sq. ft.",
    guests: "2 Guests",
    token: "TgggfpwxNjS826kKCKLc51gf",
    desc: "A comfortable, stylish interior retreat with Celebrity's premium eXhale® bedding, a sitting area and private bath.",
    perks: ["Complimentary dining", "eXhale® bedding", "Ample storage"],
  },
  {
    name: "Concierge Class Veranda",
    price: "$2,998.00",
    featured: true,
    drinks: false,
    size: "≈246 sq. ft. total",
    guests: "2 Guests",
    token: "XDyCsw1Y8hLwusYubHXBnHCj",
    desc: "Private veranda with floor-to-ceiling glass plus Concierge Class perks — welcome lunch, daily treats and personalized service.",
    perks: ["Private veranda", "Concierge service", "Welcome lunch & daily treats"],
  },
  {
    name: "Prime Ocean View",
    price: "$2,992.00",
    featured: false,
    drinks: false,
    size: "≈176 sq. ft.",
    guests: "2 Guests",
    token: "96bVmBu7CMFxE5JDwJtm34s3",
    desc: "Ocean View comfort in a more desirable location aboard the ship — natural light and beautiful sea views.",
    perks: ["Large ocean-view window", "eXhale® bedding", "Prime location"],
  },
  {
    name: "Ocean View Stateroom",
    price: "$3,098.00",
    featured: false,
    drinks: false,
    size: "≈176 sq. ft.",
    guests: "2 Guests",
    token: "eZcKWj7atQtGrs1Gd1WcYBus",
    desc: "Wake up to the sea through a large ocean-view window with a comfortable sitting area and private bath.",
    perks: ["Large ocean-view window", "eXhale® bedding", "Sitting area"],
  },
];

const EXPERIENCES = [
  "Non-Stop House Music",
  "SuncéBeat Lisbon",
  "Theme Nights",
  "Live DJ Sets",
  "Dancing",
  "Games",
  "Special Events",
  "And More!",
];

const EXPERIENCE_IMAGES = [
  "/experience/dancing.png",
  "/experience/games.png",
  "/experience/movie-night.png",
  "/experience/and-more.webp",
];

const LAUNCH_PARTY = {
  date: "Wednesday, June 16, 2027",
  venue: "Barcelona (Venue TBA)",
  location: "Barcelona, Spain",
  tagline: "It All Kicks Off The Night Before We Sail",
  intro:
    "Arrive early and start the celebration in Barcelona. Meet the House Heads At Sea family, grab your official swag and set the tone for nine unforgettable nights across Europe.",
  events: [
    {
      time: "7:00 PM",
      title: "Meet & Greet + Swag Bag Pickup",
      desc: "Connect with fellow travelers and the HHAS team while you collect your official swag bag, wristbands, lanyard and event materials.",
    },
    {
      time: "9:00 PM",
      title: "Official Launch Party",
      desc: "The pre-cruise Launch Party brings the house-music energy — live DJ sets and dancing to kick off the Europe Experience.",
    },
  ],
  note: "Pre-cruise event held in Barcelona the night before embarkation. Hotel stay booked separately.",
  image:
    "https://images.unsplash.com/photo-1578736641330-3155e606cd40?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxuaWdodGNsdWIlMjBjcm93ZCUyMGRhbmNpbmd8ZW58MHx8fHwxNzg3Nzk5MDg0fDA&ixlib=rb-4.1.0&q=85",
};

const FAQS = [
  {
    q: "Do I need a passport?",
    a: "Yes — a valid passport is required for this Spain, Portugal & Morocco sailing. Please ensure it is valid for at least 6 months beyond the June 2027 return date.",
  },
  {
    q: "When are my eDocs available?",
    a: "Celebrity Cruises opens online check-in 45 days before sailing — May 3, 2027 for our June 17 departure. Once you check in, your documents (including your mobile boarding pass, called the Xpress Pass, and printable luggage tags) are available in your Celebrity Guest Account under \"View Your Documents\" and in the Celebrity Cruises app. Your Xpress Pass shows your selected terminal arrival time.",
  },
  {
    q: "How do luggage tags work?",
    a: "Celebrity no longer mails physical bag tags. Print your electronic luggage tags from your Celebrity Guest Account (\"View Your Documents\") and securely attach one to each checked bag before arriving at the Port of Barcelona — you can print as many as you need. If you can't print, tags are available at the pier; fill them out with the porter using your stateroom number.",
  },
  {
    q: "How do I complete online check-in?",
    a: "Download the Celebrity Cruises app or log in to your Celebrity Guest Account and check in as soon as your window opens on May 3, 2027. On the website, check-in closes 3 days before sailing (June 14, 2027); the app allows check-in up until the morning of sail day. You'll enter your guest and passport details, upload your security photo, add travel details and select your terminal arrival time. Don't wait until the last minute — guests who don't check in online must complete it at the pier.",
  },
  {
    q: "What should I bring to the terminal?",
    a: "Bring your Xpress Pass (on the Celebrity app or printed), your valid passport and any required visas, and your luggage with tags already attached. Keep your passport and travel documents in your carry-on — never in checked bags. Arrive during the arrival time shown on your Xpress Pass; we embark at 5:00 PM on June 17, 2027.",
  },
];

const BIRTHDAY_MONTHS = ["May", "June", "July"];

const CABIN_OPTIONS = [
  "Inside Stateroom",
  "Prime Ocean View",
  "Ocean View Stateroom",
  "Concierge Class Veranda",
  "Not sure yet",
];

const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "The DJs", href: "#djs" },
  { label: "Ports", href: "#ports" },
  { label: "Itinerary", href: "#itinerary" },
  { label: "Cabins", href: "#pricing" },
  { label: "Community", href: "#community" },
  { label: "FAQ", href: "#faq" },
  { label: "Blog", href: "/blog" },
];

const PAYMENT = {
  depositPerPerson: 300,
  payoffDate: "2027-03-16",
};

const EARLY_BIRD = {
  deadline: "2026-11-30T23:59:59-05:00",
  holdPrice: "$100",
  deadlineLabel: "Nov 30, 2026",
};

const TESTIMONIALS = [
  {
    quote:
      "Best vacation I've ever taken. Non-stop house music, incredible people and the parties never stopped. Can't wait for Europe!",
    name: "Tanya R.",
    trip: "HHAS 2025",
    initials: "TR",
  },
  {
    quote:
      "The vibe on this cruise is unmatched. You come as a stranger and leave with a whole new family. The DJs were absolutely on fire.",
    name: "Marcus D.",
    trip: "HHAS 2024",
    initials: "MD",
  },
  {
    quote:
      "Theme nights, pool parties, beautiful destinations — every single day was a movie. The organization was flawless from start to finish.",
    name: "Kim & Andre",
    trip: "HHAS 2025",
    initials: "KA",
  },
  {
    quote:
      "I sailed solo and never felt alone for a second. So much love on that boat. The music, the dancing, the memories — worth every penny.",
    name: "Denise W.",
    trip: "HHAS 2024",
    initials: "DW",
  },
];

const GALLERY = [
  { src: "/gallery/djset.webp?v=2", caption: "Live DJ Sets", span: "lg:col-span-2 lg:row-span-2" },
  { src: "/gallery/theme.webp", caption: "Theme Nights", span: "" },
  { src: "/gallery/rwb.webp", caption: "Red, White & Black Party", span: "" },
  { src: "/gallery/poolparty.webp", caption: "Pool Party Vibes", span: "lg:col-span-2" },
  { src: "/gallery/excursions.webp", caption: "Island Excursions", span: "" },
  { src: "/gallery/allwhite.webp", caption: "All White Party", span: "lg:col-span-2" },
];

// Hotel panel: Barcelona pre-cruise stay (Launch Party is the night before we sail)
const HOTEL = {
  name: "Barcelona Pre-Cruise Stay",
  location: "Barcelona, Spain",
  tagline: "Arrive Early • Launch Party Night",
  intro:
    "Fly in before we set sail and join the pre-cruise Launch Party on June 16. We recommend arriving at least a day early and booking a hotel in central Barcelona near the cruise port so you're rested and ready for embarkation.",
  bullets: [
    "Arrive by June 16 for the pre-cruise Launch Party",
    "Stay near Port de Barcelona or the city center",
    "Explore Sagrada Família, Las Ramblas & the Gothic Quarter",
    "Hotel accommodations are booked separately",
  ],
  note: "Hotel is not included in your cruise fare. Book early — Barcelona fills up fast in June.",
  arrivalNote: "Fly into Barcelona (BCN) • Arrive by Jun 16",
  image: "/assets/europe/ports/barcelona.jpg",
};

const SUNCEBEAT = {
  kicker: "The Highlight Of The Voyage",
  title: "House Heads at SuncéBeat",
  dates: "Overnight in Lisbon · June 20–21, 2027",
  image: "/assets/europe/suncebeat.jpg",
  description:
    "The crown jewel of the Europe Experience — the Equinox docks overnight in Lisbon so we can take over Costa da Caparica for the closing weekend of SuncéBeat New Horizons. Cruise Europe by day, dance to world-class house music by the Atlantic at night.",
  included: [
    "Ship docks overnight — two full days in Lisbon",
    "House Heads group meetups at Costa da Caparica",
    "Beach days & international house-music culture",
  ],
  tickets: [
    "SuncéBeat festival admission — purchased separately",
    "Boat-party tickets — purchased separately",
    "Ground transportation to the beach — purchased separately",
    "Reserve early — House Heads group details to follow",
  ],
  note: "Final artist lineup, times and House Heads group participation are subject to confirmation. SuncéBeat is an optional add-on and is not included in your cruise fare.",
};

const HONOREE = {
  name: "Evelyn Santos",
  kicker: "Honoring a Legend • 80th Birthday",
  title: "Celebrating 80 Years of Soul",
  image: "/assets/europe/honoree/evelyn-santos.webp",
  caption:
    "Join us as we honor Evelyn Santos on her 80th birthday aboard the Europe Experience. An ICON in the House Music community and one of the few true seasoned House Heads, Evelyn carries the history, wisdom and spirit of House Music culture — and she's sailing with us to share it. Dance with her, learn from her, celebrate her.",
  promoCode: "SAN2027",
  promoText: "Use her promo code when you book",
};

const europe = {
  EVENT,
  honoree: HONOREE,
  COLORS,
  HERO_IMAGE,
  SHIP_IMAGE,
  DJS,
  PORTS,
  ITINERARY,
  BOOKING_BASE,
  CABINS,
  EXPERIENCES,
  EXPERIENCE_IMAGES,
  LAUNCH_PARTY,
  FAQS,
  BIRTHDAY_MONTHS,
  CABIN_OPTIONS,
  NAV_LINKS,
  PAYMENT,
  EARLY_BIRD,
  TESTIMONIALS,
  GALLERY,
  HOTEL,
  suncebeat: SUNCEBEAT,
  id: "europe-2027",
  themeGold: "#84FE2A",
  logo: "/logo-europe.png?v=2",
  logoAlt: "House Heads At Sea 2027 - The Europe Experience",
  experienceKicker: "9 Unforgettable Nights Of",
  hero: {
    paragraph:
      "9-Night Celebrity Equinox cruise round-trip from Barcelona through Spain, Portugal & Morocco — with an overnight in Lisbon during SuncéBeat. Nine unforgettable nights of non-stop house music, culture and connection.",
    marquee: [
      "Non-Stop House Music",
      "SuncéBeat Lisbon",
      "Theme Nights",
      "Live DJ Sets",
      "Dancing",
      "5 Countries",
      "And More!",
    ],
    countdownTarget: "2027-06-17T17:00:00+02:00",
  },
};

export default europe;
